import moment from 'moment';

angular.module('magpieResults', [
  'ui.bootstrap',
  'magpieUtil'
]).
controller('MagpieExportedResultsCtrl', function($scope, $http, baseUrlSrv) {
  const defaultError = 'Error downloading exported result.';

  $scope.loading = false;

  $scope.canSendToMap = $scope.result.format === 'DelimitedText';

  if (!$scope.canSendToMap) {
    $scope.mapTooltip = 'Send to Map is only supported for CSV Files';
  }

  function requestFile(onSuccess) {
    $scope.loading = true;

    const url = baseUrlSrv.getRestApiBase() + '/magpie/result/' + $scope.result.resultId;

    $http.head(url)
      .then(function(response) {
        onSuccess(url, response);
        $scope.loading = false;
      }, function() {
        $http.get(url)
          .then(function() {
            // success, but HEAD had an error?
            $scope.error = defaultError;
          }, function(response) {
            $scope.error = _.get(response, 'data.message', defaultError);
          })
          .finally(function() {
            $scope.loading = false;
          });
      });
  }

  function clickLink(url, download) {
    angular.element('body').append('<a id="exportedResult"></a>');
    const link = angular.element('body > a#exportedResult');
    link.attr('href', url);
    if (download) {
      link.attr('download', download);
    }
    link.attr('target', '_blank');
    link[0].click();
    link.remove();
  }

  $scope.sendResultToMap = function() {
    requestFile((url) => clickLink(`map/#/${encodeURIComponent(url)}`));
  };

  $scope.downloadResult = function() {
    requestFile((url, response) => {
      let fileSuffix = '';
      if (!_.isUndefined($scope.result.createTimestamp)) {
        const timestamp = moment.utc($scope.result.createTimestamp);
        if (timestamp.isValid()) {
          fileSuffix = '_' + timestamp.format('YYYYMMDD_HHmmss');
        }
      }

      const contentType = response.headers('Content-Type');

      let extension;
      if (contentType && contentType.startsWith('text/csv')) {
        extension = 'csv';
      } else if (contentType && contentType.startsWith('application/json')) {
        extension = 'json';
      } else {
        extension = 'txt';
      }

      clickLink(url, `magpie_export${fileSuffix}.${extension}`);
    });
  };
}).
directive('magpieExportedResult', function() {
  return {
    restrict: 'E',
    scope: {
      result: '='
    },
    templateUrl: 'components/magpie-display/results/exported-result.html',
    controller: 'MagpieExportedResultsCtrl'
  };
});



// WEBPACK FOOTER //
// ./src/components/magpie-display/results/magpie-results.js